import React from "react";
import { FaChartLine, FaMoneyBillWave, FaHome, FaCar } from "react-icons/fa";
import { HiDocumentText } from "react-icons/hi2";
import "../styles/Pages.css";

const FinancePage = ({ user }) => {
  const financeProducts = [
    {
      id: "personal",
      icon: <FaMoneyBillWave />,
      title: "Personal Loan",
      description: "Flexible loans for all your personal needs",
      rate: "From 10.5% p.a.",
      amount: "R5,000 - R250,000",
      term: "6 - 60 months",
      features: [
        "Quick approval in 24 hours",
        "No collateral required",
        "Flexible repayment terms",
        "Early settlement discounts",
      ],
    },
    {
      id: "home",
      icon: <FaHome />,
      title: "Home Loan",
      description: "Finance your dream home with competitive rates",
      rate: "From 11.75% p.a.",
      amount: "Up to R5,000,000",
      term: "Up to 30 years",
      features: [
        "Up to 100% financing",
        "Free property valuation",
        "No application fees",
        "Pre-approval available",
      ],
    },
    {
      id: "vehicle",
      icon: <FaCar />,
      title: "Vehicle Finance",
      description: "Drive away in your new car today",
      rate: "From 9.25% p.a.",
      amount: "R50,000 - R1,500,000",
      term: "12 - 72 months",
      features: [
        "New and used vehicles",
        "Trade-in assistance",
        "Balloon payment options",
        "Comprehensive insurance",
      ],
    },
    {
      id: "business",
      icon: <FaChartLine />,
      title: "Business Loan",
      description: "Grow your business with tailored financing",
      rate: "From 12% p.a.",
      amount: "R10,000 - R5,000,000",
      term: "12 - 84 months",
      features: [
        "Working capital solutions",
        "Equipment financing",
        "Business expansion loans",
        "Dedicated relationship manager",
      ],
    },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Finance Solutions</h1>
        <p className="page-subtitle">
          Achieve your goals with our flexible financing options
        </p>
      </div>

      <div className="finance-products">
        <h3>Finance Products</h3>
        <div className="products-grid">
          {financeProducts.map((product) => (
            <div key={product.id} className="finance-card">
              <div className="finance-icon">{product.icon}</div>
              <h4>{product.title}</h4>
              <p>{product.description}</p>

              <div className="finance-details">
                <div className="detail-item">
                  <span className="detail-label">Interest Rate</span>
                  <span className="detail-value">{product.rate}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Loan Amount</span>
                  <span className="detail-value">{product.amount}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Loan Term</span>
                  <span className="detail-value">{product.term}</span>
                </div>
              </div>

              <div className="finance-features">
                <h5>Features</h5>
                <ul>
                  {product.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>

              <button className="btn-outline">Learn More</button>
            </div>
          ))}
        </div>
      </div>

      <div className="finance-documents">
        <h3>
          <HiDocumentText /> Required Documents
        </h3>
        <div className="documents-list">
          <div className="document-requirement">
            <h4>For Personal Loans</h4>
            <ul>
              <li>Valid ID document</li>
              <li>Proof of income (latest 3 payslips)</li>
              <li>Bank statements (3 months)</li>
              <li>Proof of residence</li>
            </ul>
          </div>
          <div className="document-requirement">
            <h4>For Home Loans</h4>
            <ul>
              <li>Valid ID document</li>
              <li>Proof of income</li>
              <li>Bank statements (6 months)</li>
              <li>Property details</li>
              <li>Offer to purchase</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancePage;
